/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


const AdminPageTitle = "Argos User Database"
export interface AdminUserControlRow {

    id: string
    firstName: string
    lastName: string
    email: string
    loginCount: number
    loginTs: string
    userStatus: string
}


export { AdminPageTitle };